export const DEFAULT_THEME = 'default-theme';

// Color class for product themes (Aurora, Everest, ...). It carries no fixed
// colors of its own, the selected product's primary/secondary/tertiary are
// fed in as inline custom properties on the root element and the full ramp is
// derived from them (see blue.color.theme.scss `theme-ramp`).
export const PRODUCT_THEME = 'product-theme';

export const DarkLightSettings = {
  dark: 'dark',
  light: 'light',
  auto: 'auto',
};

export const ThemeColorSettings = {
  green: 'green-theme',
  blue: 'blue-theme',
  red: 'red-theme',
  yellow: 'yellow-theme',
  purple: 'purple-theme',
  pink: 'pink-theme',
  orange: 'orange-theme',
  turquoise: 'turquoise-theme',
  vivaMagenta: 'viva-magenta-theme',
  gray: 'gray-theme',
  aquamarine: 'aquamarine-theme',
  brown: 'brown-theme',
  cornflowerBlue: 'cornflower-blue-theme',
  royalPurple: 'royal-purple-theme',
  eggplant: 'eggplant-theme',
  blurple: 'blurple-theme',
};

export const ThemeDesignSettings = {
  round: 'round-theme',
  counterBorders: 'counter-borders-theme',
  sharp: 'sharp-theme',
  leaf: 'leaf-theme',
  circle: 'circle-theme'
};
